var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13455_161523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.483 0L24.6963 5.21333V32H0.696289V0H19.483Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6943 10.5273V5.33398H19.501",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.501 0V5.19333H24.6943",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9697 13.0801H13.3031C12.5667 13.0801 11.9697 13.677 11.9697 14.4134V29.7467C11.9697 30.4831 12.5667 31.0801 13.3031 31.0801H25.9697C26.7061 31.0801 27.3031 30.4831 27.3031 29.7467V14.4134C27.3031 13.677 26.7061 13.0801 25.9697 13.0801Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6377 20.4137V15.7471H25.3044",
    stroke: "#0450CF",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30176 11.0798V6.41309H5.96842V11.0798",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96973 11.0801V3.08008H10.6364V11.0801",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6377 11.0801V5.08008H15.3044V11.0801",
    fill: "#F5821F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30176 13.7471H9.96842",
    stroke: "#7EB3FF",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30176 16.4131H9.96842",
    stroke: "#7EB3FF",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30176 19.0801H7.96842",
    stroke: "#7EB3FF",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3034 16.3066H15.1768V20.4133H25.3034V16.3066Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7026 21.7402H13.9893V24.4536H16.7026V21.7402Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0034 21.7402H18.29V24.4536H21.0034V21.7402Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3042 21.7402H22.5908V24.4536H25.3042V21.7402Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7026 25.6738H13.9893V28.3872H16.7026V25.6738Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0034 25.6738H18.29V28.3872H21.0034V25.6738Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3042 21.7402H22.5908V28.3936H25.3042V21.7402Z",
    fill: "#B2D2EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13455_161523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6067,
    height: 32,
    fill: "white",
    transform: "translate(0.696289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialProjectsIcon);
export default __webpack_public_path__ + "static/media/special-projects-icon.8141d7598420f8c7ed9c3e8c9bd0f78f.svg";
export { ForwardRef as ReactComponent };